import styled from "styled-components";
import {device, TYPE_DECOUPE, TYPE_PLIAGE} from "../../helper/constants";
import {
    DECOUPE_FORMS,
    DECOUPE_FORMS_BOIS_ONLY,
    DECOUPE_FORMS_BOIS_PLEXI_MV, DECOUPE_FORMS_MV_ONLY,
    MATERIAL_SHADES,
    PLIAGE_FORMS
} from "../../helper/materials";
import {ConfigurateurContext} from "../../context/context";
import DimensionInput from "../DimensionInput";
import {getFormFromMid} from "../../helper/function";
import FacesCheckbox from "../FacesCheckbox";
const {
    element: {
        useContext,
    },
} = wp;
const Wrapper = styled.div`
  flex-basis: 100%;
  padding: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const IconContainer = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  
  & img {
    /*width: 240px;*/
    max-height: 250px;
    border-radius: 0 !important;
  }
  @media ${device.tablet} {

  }
  @media ${device.mobile} {
    flex-basis: 100%;
  }
`;

const CheckFace = styled.span`
  margin-right: 20px;
`;

const DetailContainer = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  
  @media ${device.tablet} {

  }
  @media ${device.mobile} {
    flex-basis: 100%;
  }
`;

export default function DimensionContainer({fid, type, material, shade}) {

    const {dimensions, setDimensions, form, thickness, currentMaterial, setOption} = useContext(ConfigurateurContext);

    const handleInputChange = (inputName, inputValue) => {
        const newDimensions = {
            ...dimensions,
            [inputName]: inputValue,
        }
        setDimensions(newDimensions);
    }

    const handleOptionsChange = (newOption) => {
        setOption(newOption);
    }
    const getIcon = () => {
        if (type === TYPE_DECOUPE) {
            if (currentMaterial === 'melamine') {
                return getFormFromMid(currentMaterial)[fid].iconDetailOption;
            } else {
                return getFormFromMid(currentMaterial)[fid].iconDetail;
            }
        }
        if (type === TYPE_PLIAGE) {
            return PLIAGE_FORMS[fid].iconDetail;
        }
    }

    let thisForm = DECOUPE_FORMS_BOIS_PLEXI_MV[fid] ?? (DECOUPE_FORMS_BOIS_ONLY[fid] ?? DECOUPE_FORMS_MV_ONLY[fid]);

    console.log(fid);
    console.log(thisForm);
    return (
        <Wrapper>
            <IconContainer>
                <img src={getIcon()} alt={"Form"} />
            </IconContainer>
            <DetailContainer>
                {type === TYPE_DECOUPE && (
                    <>
                        <div>
                            {getFormFromMid(currentMaterial)[fid].dimensions.map(value => (
                            <DimensionInput
                                type={type}
                                inputName={value}
                                currentValue={dimensions ? dimensions[value] : ''}
                                handleInputChange={handleInputChange}
                                form={form}
                                dimension={dimensions}
                                thickness={thickness}
                                material={material}
                                shade={shade}
                            />
                            ))}
                        </div>
                        <div>
                            {(MATERIAL_SHADES[material][shade]['option'] && thisForm['faces']) ? (
                                <>
                                    <div>{MATERIAL_SHADES[material][shade]['option']} ?</div>
                                    <FacesCheckbox list={thisForm['faces']} handleChange={handleOptionsChange} />
                                </>
                            ) : ''
                            }
                        </div>
                    </>
                )}
                {type === TYPE_PLIAGE && (
                    PLIAGE_FORMS[fid].dimensions.map(value => (
                        <DimensionInput
                            type={type}
                            inputName={value}
                            currentValue={dimensions ? dimensions[value] : ''}
                            handleInputChange={handleInputChange}
                            dimension={dimensions}
                            thickness={thickness}
                        />
                    ))
                )}
            </DetailContainer>
        </Wrapper>
    )
}